import { Pipe, PipeTransform } from '@angular/core';
import { getMoment } from '../services/datetime.service';
import { environment } from 'src/environments/environment';
import * as moment from 'moment';

@Pipe({
  name: 'fullDateTimePresentation'
})
export class FullDateTimePresentationPipe implements PipeTransform {

  constructor() { }

  /**
   * Format date to 'DD/MM/YYYY HH:mm:ss'
   * @param value date
   */
  public transform(value: string): string {
    if (value === '0001-01-01T00:00:00+00:00' || value === '1900-01-01T00:00:00+00:00'
      || value === null || value === undefined || value === '') {
      return '-';
    } else {
      const format = `${environment.dateFormatPresentation} ${environment.timeFormat}`;
      const date = getMoment(value).format(format);
      return date;
    }
  }

}
